import React from 'react';

import { Map, ArrowRight } from 'lucide-react';

import { MCSA_FINISH_HERO, MCSA_JOURNEY_COPY } from '../../../../helpers/mcsa-journey.copy';

interface JourneyFinishProps {
    onBackToMap: () => void;
    onViewResults: () => void;
}

export const JourneyFinish = (props: JourneyFinishProps) => {
    const { onBackToMap, onViewResults } = props;

    return (
        <div className='mcsa_journey_finish'>
            <div className='mcsa_journey_finish__inner'>
                <div className='mcsa_journey_finish__hero'>
                    <img src={MCSA_FINISH_HERO} alt='' />
                </div>
                <h2 className='text-light color--primary'>{MCSA_JOURNEY_COPY.finish_title}</h2>
                <p>
                    {MCSA_JOURNEY_COPY.finish_body_before}
                    <b>{MCSA_JOURNEY_COPY.finish_body_highlight}</b>
                    {MCSA_JOURNEY_COPY.finish_body_after}
                    <br />
                    <b>{MCSA_JOURNEY_COPY.finish_stay}</b>
                </p>
                <div className='mcsa_journey_finish__actions'>
                    <button type='button' className='btn btn--lg btn--radius-full btn--secondary' onClick={onBackToMap}>
                        <Map />
                        <span>{MCSA_JOURNEY_COPY.back_to_map}</span>
                    </button>
                    <button type='button' className='btn btn--lg btn--radius-full btn--primary' onClick={onViewResults}>
                        <span>{MCSA_JOURNEY_COPY.view_results}</span>
                        <ArrowRight />
                    </button>
                </div>
            </div>
        </div>
    );
};
